const menuList = document.querySelectorAll('.menu > li > span')
const burgerBtn = document.querySelector('.header__burger')
const headerCheckbox = document.querySelector('#header__checkbox')
const body = document.querySelector('body')


menuList.forEach(menu=>{
  menu.addEventListener('click', function (){
    this.closest('li').classList.toggle('open');
    // body.toggle('hiddenOverflow')
    // this.classList.contains('open') ? body.classList.add('hiddenOverflow') : body.classList.remove('hiddenOverflow');
  })
})

burgerBtn.addEventListener('click', function (){
  console.log(headerCheckbox.checked)
  headerCheckbox.checked ? body.classList.remove('hiddenOverflow') : body.classList.add('hiddenOverflow')
})
